import { FC, useCallback, useMemo } from 'react';
import { SelectChangeEvent } from '@mui/material';

import { CustomerJobStatus } from 'domain/entities/CustomerJob';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import Select from 'targets/web/components/Select';

interface Props {
  onChange: (status?: CustomerJobStatus) => void;
  value?: CustomerJobStatus;
  allowedStatuses?: CustomerJobStatus[];
}

const StatusPicker: FC<Props> = ({ onChange, value, allowedStatuses }) => {
  const t = useTranslationPrefix('components.filters_container');

  const items: { value: CustomerJobStatus | 'all'; label: string }[] = useMemo(
    () => [
      { value: 'all', label: t('customer_job_status.all') },
      ...(
        allowedStatuses || [
          CustomerJobStatus.Values.submitted,
          CustomerJobStatus.Values.approved,
          CustomerJobStatus.Values.in_progress,
          CustomerJobStatus.Values.completed,
          CustomerJobStatus.Values.declined,
          CustomerJobStatus.Values.cancelled,
        ]
      ).map((s) => ({
        value: s,
        label: t(`customer_job_status.${s}`),
      })),
    ],
    [t, allowedStatuses],
  );

  const handleChange = useCallback(
    (e: SelectChangeEvent<CustomerJobStatus | 'all'>) => {
      onChange(e.target.value === 'all' ? undefined : (e.target.value as CustomerJobStatus));
    },
    [onChange],
  );

  return (
    <Select
      defaultValue="all"
      value={value ?? 'all'}
      items={items}
      label={t('job_status_label')}
      onChange={handleChange}
    ></Select>
  );
};

export default StatusPicker;
